import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 893;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = 'b735a0ff-62d8-455f-a748-747dd0332f89-893';
    
    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
